import React from 'react'

const ProgramPlaceholder = () => {
    return(
        <div className='d-flex flex-sm-column flex-row-reverse justify-content-start pe-4'>
            <div className=' position-relative mb-sm-0 mb-3 placeholder bgcolor-primary' style={{width:'370px', height:'563px'}}>
                <div className='position-absolute top-0 start-0 w-100 h-100'>
                    <div className='bgcolor-program-card w-100 h-100 d-flex justify-content-center align-items-end'>
                        <div className='px-1 mb-2 text-center bg-white placeholder col-11'>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProgramPlaceholder